import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NerdMenuElementType } from 'src/common/enums';
import { BoldLink, FilledLink, OutlinedLink, RegularLink } from './NerdMenuLinks';

const NerdMenuFooterUtility = (props: { menus: NerdMenuElement[] }) => {
  const { t } = useTranslation();

  return props.menus.map(link => {
    let item = <RegularLink link={link} className="pds-text-body-sm" />;

    if (link.type === NerdMenuElementType.BOLD) {
      item = <BoldLink link={link} className="pds-text-body-sm" />;
    }

    if (link.type === NerdMenuElementType.OUTLINED) {
      item = <OutlinedLink link={link} className="pds-text-body-sm" />;
    }

    if (link.type === NerdMenuElementType.FILLED) {
      item = <FilledLink link={link} className="pds-text-body-sm" />;
    }

    if (link.type === NerdMenuElementType.COOKIE_CONSENT) {
      const linkWithOneTrust = { ...link, link: { url: '#toggleOneTrust', title: '' } };
      item = (
        <div className="pds-flex pds-items-center pds-gap-2">
          <RegularLink
            link={linkWithOneTrust}
            className="pds-text-body-sm"
            onClick={() => {
              window.OneTrust.ToggleInfoDisplay();
            }}
          />
          <StaticImage
            src="../../../assets/media/images/icon-privacy.png"
            alt={t('California Consumer Privacy Act (CCPA) Opt-Out Icon')}
            width={38}
          />
        </div>
      );
    }
    return (
      <li key={link.drupal_id} className="pds-min-w-max">
        {item}
      </li>
    );
  });
};

export default NerdMenuFooterUtility;
